import { API, graphqlOperation } from 'aws-amplify';
import React, { useState } from 'react';
import Moment from 'moment';
import { Link } from 'react-router-dom';

import './styles.scss';

import Layout from '../../components/Layout';
import { userInfo, useUser } from '../../contexts/user';
import { ClassicBanner } from '../../components/Banner';

const getWallByRecipientId = `query WallByRecipientId($recipientId: String) {
    wallByRecipientId(
        recipientId: $recipientId
        limit: 100,
        sortDirection: DESC        
    ){
        items {
            wall {
                id
                status
                senderName
                config
                createdAt
            }
        }
        nextToken
        }
    }
`

const getWallBySenderId = `query WallBySenderId($senderId: String) {
    wallBySenderId(
        senderId: $senderId,
        limit: 100,
        sortDirection: DESC
    ) {
      items {
        id
        status    
        senderName
        config
        recipients {
            items {
                recipientName
            }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`

const WallItem = ({ wall, status }) => {
    return (
        <div className="box mx-2 mt-4 mb-6 px-2">
            <nav className="level has-text-centered mb-1">
                <div className="level-item item-box">
                    <div>
                        <p className="heading">Organizer</p>
                        <p className="title is-size-7 truncate tag is-white has-words-wrapped unset-height">{wall.senderName}</p>
                    </div>
                </div>

                <div className="level-item item-box border-sides-grey">
                    <div>
                        <p className="heading">Created</p>
                        <p className="title is-size-7 tag is-white has-words-wrapped unset-height">{Moment(wall.createdAt).format('DD/MM/YYYY')}</p>
                    </div>
                </div>

                <div className="level-item item-box">
                    <div>
                        <p className="heading">Status</p>
                        <p className="title is-size-7 tag is-info has-words-wrapped unset-height">{status}</p>
                    </div>
                </div>
            </nav>

            <hr />
            <Link to={`/greeting/${wall.id}`}>
                <ClassicBanner data={JSON.parse(wall.config)} heroClassName="px-1 py-1" titleOnly />
            </Link>
            <hr />

            <div className="buttons is-centered">
                <Link to={`/greeting/${wall.id}`}>
                    <button className="has-text-weight-bold button is-primary px-3">View</button>
                </Link>
            </div>
        </div>
    );
}

const OrganizedContent = ({ active, userId }) => {
    const [walls, setWalls] = React.useState([])

    React.useEffect(() => {
        const getWalls = async () => {
            try {
                const input = { senderId: userId }
                const resp = await API.graphql(graphqlOperation(getWallBySenderId, input));
                setWalls(resp.data.wallBySenderId.items)
            } catch (error) {
                console.log('Something went wrong', error);
            }
        }

        getWalls();
    }, [userId]);

    return (
        <div className={`${active === true ? 'box show-tab' : 'hide-tab'}`}>
            {walls.length ? (
                <>
                    <div className="title px-4 is-size-4 pt-3 pb-4 has-text-grey has-text-centered">
                        You have organized {walls.length} greeting wall(s)
                    </div>
                    
                    <hr/>

                    {walls.map((wall, index) => (
                        <WallItem key={`owall_${index}`} wall={wall} 
                            status={wall.recipients.items.length > 0 ? 'DELIVERED' : 'OPEN'} />
                    ))}
                </>
            ) : (
                    <NoContent message=" You have not organized any greeting wall yet" />
                )
            }

        </div>
    );
}


const NoContent = ({ message }) => {
    return (
        <section className='hero is-bold is-medium'>
            <div className='hero-body'>
                <div className='container'>
                    <div className="title px-4 is-size-4 pb-4 has-text-grey has-text-centered line-height-15">
                        {message}
                    </div>
                </div>
            </div>
        </section>
    )
}
const ReceivedContent = ({ active, userId }) => {
    const [walls, setWalls] = React.useState([])

    React.useEffect(() => {
        const getWalls = async () => {
            try {
                const input = { recipientId: userId }
                const resp = await API.graphql(graphqlOperation(getWallByRecipientId, input));
                setWalls(resp.data.wallByRecipientId.items)
            } catch (error) {
                console.log('Something went wrong', error);
            }
        }

        getWalls();
    }, [userId]);


    return (
        <>
            <div className={`${active === true ? 'show-tab box' : 'hide-tab'}`}>
                {walls.length ? (
                    <>
                        <div className="title px-4 is-size-4 pt-3 pb-4 has-text-grey has-text-centered">
                            You have received {walls.length} greeting wall(s)
                        </div>

                        <hr/>

                        {walls.map((item, index) => (
                            <WallItem key={`rwall_${index}`} wall={item.wall} 
                                status="DELIVERED" />
                        ))}
                    </>
                ) : (
                        <NoContent message="You have not received any Wallknown greetings yet" />
                    )
                }
            </div>
        </>
    );
}

const Banner = ({ userName }) => {
    return (
        <section className='hero is-primary is-bold'>
            <div className='hero-body'>
                <div className='container'>
                    <div className='columns is-vcentered has-text-centered'>

                        <div className='column' >
                            <div className='section'>
                                <h1 className='title has-text-weight-semibold is-size-3'>
                                    Welcome back, {userName}
                                </h1>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}


const DashboardPage = () => {
    const { user } = useUser();
    const { userId, userName } = userInfo(user)

    const [activeTab, setActiveTab] = useState(0)
    const onTabChange = (tabIndex) => {
        if (activeTab !== tabIndex) {
            setActiveTab(tabIndex)
        }
    }

    return (
        <Layout>
            <Banner userName={userName} />

            <section>
                <nav className="panel pt-4">
                    <div className='columns is-centered px-0 mx-1'>

                        <main className="main pb-6 column">
                            <p className="dashboard-tabs panel-tabs mb-4 is-small-caps box">
                                <a href="#organized" className={`px-3 ${activeTab === 0 ? 'is-active' : ''}`} onClick={() => onTabChange(0)}>Organized</a>
                                <a href="#received" className={`px-3 ${activeTab === 1 ? 'is-active' : ''}`} onClick={() => onTabChange(1)}>Received</a>
                            </p>


                            <OrganizedContent userId={userId} active={activeTab === 0 ? true : false} />
                            <ReceivedContent userId={userId} active={activeTab === 1 ? true : false} />

                        </main>
                    </div>

                </nav>

            </section>
        </Layout>
    );
}

export default DashboardPage;